export { default } from './Portal';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Portal/index.js
// module id = 92
// module chunks = 0